var map = {
	"./1.mp3": 2318,
	"./2.mp3": 4753,
	"./Aghani Wataniyah/بلادي الامارات_المجموعة_3.mp3": 7850,
	"./Aghani Wataniyah/جيش الامارات._كورال الامارات_1-01.mp3": 5060,
	"./Aghani Wataniyah/شميمية قبيلية_كورال الامارات -01.mp3": 3162,
	"./Aghani Wataniyah/صقور زايد  _عادل ابراهيم-01.mp3": 9649,
	"./Aghani Wataniyah/هذا علمنا_كورال الامارات_1-01.mp3": 8095,
	"./Aghani Wataniyah/وطنا_حسين الجسمي.mp3": 9826,
	"./Aghani Wataniyah/يا شروق المجد_حسين الجسمي .mp3": 1915,
	"./rest1.mp3": 2512,
	"./rest2.mp3": 7447,
	"./rest3.mp3": 2514,
	"./اغاني مهداة للشيوخ/(غناء محمد الماسي و فرقة نعمان الحربية (عاش بو خالد.mp3": 2841,
	"./اغاني مهداة للشيوخ/بو خالد_عيضة المنهالي.mp3": 2990,
	"./اغاني مهداة للشيوخ/حسين الجسمي - حامي الدار (حصرياً) _ 2023 _ Hussain Al Jassmi - Hami Eldar.mp3": 6350,
	"./اغاني مهداة للشيوخ/حصن الوطن_مجموعة كورال الامارات.mp3": 9075,
	"./اغاني مهداة للشيوخ/رجال محمد _كورال مجموعة الامارات.mp3": 4235,
	"./اغاني مهداة للشيوخ/رفعت رأسي - كلمات صاحب السمو الشيخ محمد بن زايد آل نهيان.mp3": 851,
	"./اغاني مهداة للشيوخ/رمز الوطن _كورال مجموعة الامارات.mp3": 8299,
	"./اغاني مهداة للشيوخ/زعيم المدار_حسين الجسمي.mp3": 6848,
	"./اغاني مهداة للشيوخ/عقال المرجله - بوخالد_حسين الجسمي.mp3": 7706,
	"./تحميل-اغنية-أنا-العلم-بلقيس-فتحي.mp3": 9772,
	"./تحميل-اغنية-يا-عملنا-بلقيس-فتحي-وحسين-الجسمي.mp3": 6498,
	"./تحميل-اغنية-يا-عملنا-للأطفال.mp3": 5091,
	"./تحميل-اغنية-يحيا-علم-اليوم-يومك-يا-علم.mp3": 6163,
	"./شهيد/اتهجى حروفك_شهد العميري_1.mp3": 3270,
	"./شهيد/شهداء الامارات - المجموعة._المجموعة_1.mp3": 3876,
	"./شهيد/وصية شهيد_المجموعة_1.mp3": 246,
	"./عيشي بلادي.mp3": 2418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4328;